import {ProjectMember, TeamObj} from 'common/report/queries/app-api/workspaces-client';
import {BaseEntityId, SharableEntityGrant, SharableEntityType} from 'common/report/util/saved-entities/types';
import type {PublicDashboardLink} from 'common/report/queries/app-api/public-dashboard-links-client-types';
import {UpsellInfo} from 'common/widgets/in-product-upsell-modal/util';

import {LoadingStatus} from '../types';

export interface SharingModalState {
  searchText: string;
  shortUrl: string;
  shortUrlFetchStatus: string;
  showCopyLinkText: boolean;
  shortUrlLoading: boolean;
  showPopover: boolean;
  pendingGrants: Set<ProjectMember | TeamObj>;
  pendingCanEdit: boolean;
  availableMembers: {
    loading: LoadingStatus;
    data: ProjectMember[];
    error: Error;
  };
  availableTeams: {
    loading: LoadingStatus;
    data: TeamObj[];
    error: Error;
  };
  currentGrants: {
    loading: LoadingStatus;
    data: SharableEntityGrant;
    error: Error;
  };
  publicDashboardLinks: {
    loading: LoadingStatus;
    data: PublicDashboardLink[];
    error: Error;
  };
  currentPublicDashboardLink: PublicDashboardLink;
  currentGrantsSnapshot: {
    data: SharableEntityGrant;
  };
  projectStoreLoading: LoadingStatus;
  publicDashboardEnabled: boolean;
  modalViewType: SharingModalViewType;
  expandedPublicDashboardRows: Set<number>;
  upsellInfo: UpsellInfo;
}

export interface SharingModalAttrs {
  open: boolean;
  type: SharableEntityType;
  id: BaseEntityId;
  'entity-name'?: string;
  'project-id': number;
  disabled: boolean;
  'disabled-reason': string;
  'open-as': SharingModalViewType;
  'is-superadmin': boolean;
  'open-password-row-item': OpenPasswordRowItem;
  'entity-owner-id': number;
}

export type OpenPasswordRowItem = {
  PublicLinkId: string;
  LastSavedPassword: string;
};

export enum SharingModalViewType {
  Sharing = `sharing`,
  PublicDashboardDetails = `publicDashboardDetails`,
}

export enum ShareOptionsLocation {
  ProjectShare = `projectShare`,
  PickerControls = `pickerControls`,
  UserOrTeamShare = `userOrTeamShare`,
}

export enum SharingModalDisabledReason {
  Viewer = `components.sharing.error.viewer`,
  Consumer = `components.sharing.error.consumer`,
  Default = `components.sharing.error.default`,
}

export interface PublicDashboardLinkRow {
  publicLink: string;
  dataView: string;
  canEdit: boolean;
  creator: string;
  createdDate: string;
  passwordProtected: string;
  embedLink: string;
}
